import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { StyledBar as CompiledStyledBar } from './styledBar-compiled';
import { StyledBar as EmotionStyledBar } from './styledBar-emotion';
export var StyledBar = function StyledBar(props) {
  return fg('platform_media_compiled') ? /*#__PURE__*/React.createElement(CompiledStyledBar, props) : /*#__PURE__*/React.createElement(EmotionStyledBar, props);
};